import { IChannelServiceMock } from "./channel.types";

export const mockChannelService = (): IChannelServiceMock => ({
  getChannelsPage: jest.fn(),
  createChannel: jest.fn(),
});
